import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from 'src/app/store/core/url/customizeHttpUrlGenerator';
import { CommunicationConfigurationEmailSenderModel } from '../../../api/entity/communicationConfigurationEmailSender.model';
import { CommunicationConfigurationEmailSenderConverter } from '../../../api/entity/converter/communicationConfigurationEmailSender.converter';

@Injectable({
    providedIn: 'root'
})
export class CommunicationConfigurationEmailSenderDataService extends AbstractDataServiceV2<CommunicationConfigurationEmailSenderModel, CommunicationConfigurationEmailSenderConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: CommunicationConfigurationEmailSenderConverter
    ) {
        super('CommunicationConfigurationEmailSender', http, httpUrlGenerator, logger, config, converter);
    }
}